import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {Switch} from "antd";

//action imports
import { settingsFieldUpdated, languageSwitch } from "../../../actions/SettingsActions";

//component imports

class SetLanguage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            english: false
        };

        this.onLanguageSwitch = this.onLanguageSwitch.bind(this);
    }

    componentWillMount() {
        if (!(_.isEmpty(this.props.profile))) {
            this.setState({ english: this.props.profile.english });
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.profile !== this.props.profile) {
            this.setState({ english: nextProps.profile.english });
        }
    }

    onLanguageSwitch() {
        //extract state
        const { english } = this.state;
        this.setState({ english: !english });

        this.props.languageSwitch({ english: !this.state.english });
    }

    render() {
        return (
            <div className={"migrationBox"}>
                <div style={{ marginBottom: '2rem'}}>
                </div>
                <hr/>

                <div>
                    <h3>English/Swahili</h3>
                    <Switch
                        checkedChildren="English"
                        unCheckedChildren="Kiswahili"
                        onChange={() => this.onLanguageSwitch()}
                        checked={this.state.english}
                    />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const { profile } = state.profile;

    return {
        profile,
    }
};

export default connect(mapStateToProps, { settingsFieldUpdated, languageSwitch })(SetLanguage);
